function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-4 -1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.664,6H19.717V7.965h1.473a.491.491,0,0,1,.491.491V23.682a.491.491,0,0,1-.491.491H6.456a.491.491,0,0,1-.491-.491V8.456a.491.491,0,0,1,.491-.491H7.929V6H4.982A.982.982,0,0,0,4,6.982V25.155a.982.982,0,0,0,.982.982H22.664a.982.982,0,0,0,.982-.982V6.982A.982.982,0,0,0,22.664,6Z",
  transform: "translate(-4 -3.544)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.332,3.456H21.367a2.456,2.456,0,1,0-4.912,0H14.491A.491.491,0,0,0,14,3.947V6.4a.491.491,0,0,0,.491.491h8.841a.491.491,0,0,0,.491-.491V3.947A.491.491,0,0,0,23.332,3.456Zm-4.42.982a.982.982,0,1,1,.982-.982A.982.982,0,0,1,18.912,4.438Z",
  transform: "translate(-9.088 -1)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.947,27.4a.49.49,0,0,1-.347-.144L16.144,24.8a.491.491,0,1,1,.695-.695l2.109,2.109,4.073-4.073a.491.491,0,0,1,.695.695l-4.42,4.42A.49.49,0,0,1,18.947,27.4Z",
  transform: "translate(-10.106 -11.685)",
  fill: "#fff"
})));

var SvgAlert2 = function SvgAlert2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.646,
    height: 22.593,
    viewBox: "0 0 19.646 22.593",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-2.9ce662d2.svg";
export { ForwardRef as ReactComponent };